import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';
import * as React from 'react';

import { GalleryControlsContainer } from './controls/container';
import * as styles from './index.css';
import { GalleryContainer } from '../../containers/GalleryContainer';
import { MortgagedPropertyLabelsContainer } from '../../containers/MortgagedPropertyLabelsContainer';
import { NewbuildingPromoLabelContainer } from '../../containers/NewbuildingPromoLabel/NewbuildingPromoLabel';
import { CountrysidePromoLabelContainer } from '../CountrysidePromotionsLabel/container';

export interface IOfferGalleryProps {
  reactErrorLogger: ILogger;
  isTiledCarouselAvailable?: boolean;
  hidePhoneButton?: boolean;
  hideFavoritesButton?: boolean;
}

export class OfferGallery extends React.Component<IOfferGalleryProps, {}> {
  public render() {
    const { reactErrorLogger, isTiledCarouselAvailable = false, hideFavoritesButton, hidePhoneButton } = this.props;

    if (isTiledCarouselAvailable) {
      return null;
    }

    return (
      <div className={styles['photo_gallery_container']} id="photos">
        <ErrorLogComponent logger={reactErrorLogger}>
          <GalleryContainer phoneButton={!hidePhoneButton} favoritesButton={!hideFavoritesButton} />
        </ErrorLogComponent>
        <GalleryControlsContainer />
        <MortgagedPropertyLabelsContainer />
        <NewbuildingPromoLabelContainer />
        <CountrysidePromoLabelContainer />
      </div>
    );
  }
}
